import React from "react";
//mui
import {
	Box,
	Typography,
	Stack,
	Grid,
	Button,
	CircularProgress,
	FormControl,
	Select,
	MenuItem,
	FormControlLabel,
	Checkbox,
	Divider,
} from "@mui/material";
//components
import {
	SvgIconStyle,
	CommonCounter,
	CommonInput,
	CommonModal,
} from "components";
import { EmailInputStyle, EmailSelectInputStyle } from "utils/uiData";
import { fDate } from "utils/formatTime";

import ArrowIcon from "assets/icons/arrow.svg";
import DownArrowIcon from "assets/icons/arrow-down.svg";
import CartArrowIcon from "assets/icons/prev.svg";
import CancelIcon from "assets/icons/cancel.svg";
import RemoveIcon from "assets/icons/remove.svg";
import MenuIcon from "assets/icons/menu.svg";
import SymbolIcon from "assets/icons/symbol.svg";
import CartIcon from "assets/icons/cart.svg";
import UncheckedIcon from "assets/icons/unchecked.svg";
import CheckedIcon from "assets/icons/checked.svg";

import { rmBr } from "../utils/string.utils";

// import { useTranslation } from "next-i18next";

export function TabPanel(props) {
	const { children, value, index, ...other } = props;
	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`item-tab-${index}`}
			{...other}
		>
			{value === index && children}
		</div>
	);
}

export function ItemCard({ language, item, ...other }) {
	return (
		<Grid item sx={{ pointer: "cursor" }} {...other}>
			{item?.thumbnailImage ? (
				<Box
					sx={{
						backgroundColor: "grey.400",
						width: "100%",
						// maxWidth: 205,
						// minWidth: 205,
						// minHeight: 162,
						minWidth: 210,
						minHeight: 210,
						borderRadius: "4px",
						background: `center/cover no-repeat url(${item?.thumbnailImage})`,
					}}
				/>
			) : (
				<Box
					sx={{
						backgroundColor: "grey.400",
						width: "100%",
						minWidth: 205,
						paddingBottom: "75%",
						borderRadius: "4px",
						background: `center/30% no-repeat #ededed url(${SymbolIcon.src})`,
						opacity: 0.6,
					}}
				></Box>
			)}

			<Typography
				fontSize={18}
				fontWeight={700}
				mt={1.5}
				mb={1}
				lineHeight={1}
				sx={{
					textOverflow: "ellipsis",
					whiteSpace: "nowrap",
					overflow: "hidden",
					wordBreak: "break-all",
				}}
			>
				{item?.menuName}
			</Typography>
			<Typography
				fontSize={14}
				color="grey.middle"
				lineHeight={1}
				sx={{
					textOverflow: "ellipsis",
					whiteSpace: "nowrap",
					overflow: "hidden",
					wordBreak: "break-all",
					minHeight: "18px",
				}}
			>
				{item?.menuSubTitle}
			</Typography>
			<Typography
				fontSize={20}
				fontWeight={700}
				color="primary.main"
				lineHeight={1}
			>
				{Number(item?.priceKRW).toLocaleString()}원
			</Typography>
		</Grid>
	);
}

// 슬라이드 좌우 버튼
export function ItemArrow({ prev, onClick }) {
	return (
		<Box
			sx={{
				display: "block",
				position: "absolute",
				bottom: "50%",
				left: prev ? "32px" : "",
				right: prev ? "" : "8px",
				transform: "translate(-50%,0)",
				zIndex: "99",
			}}
		>
			<Button
				variant="icon"
				sx={{
					color: "primary.main",
					p: 0,
					alignItems: "center",
				}}
				onClick={onClick}
			>
				{prev ? <SvgIconStyle src={ArrowIcon} size={25} /> : null}
				{prev ? null : (
					<SvgIconStyle
						src={ArrowIcon}
						size={25}
						sx={{ transform: "rotate(180deg)" }}
					/>
				)}
			</Button>
		</Box>
	);
}

export function CartArrow({ prev, onClick }) {
	return (
		<Box
			sx={{
				display: "block",
				position: "absolute",
				bottom: "20%",
				left: prev ? -100 : "",
				right: prev ? "" : 0,
				minHeight: "80px",
				zIndex: "99",
			}}
		>
			<Button sx={{ p: 0 }} onClick={onClick}>
				{prev ? (
					<SvgIconStyle origin src={CartArrowIcon} size={50} sx={{ mr: 1.5 }} />
				) : null}
				{prev ? null : (
					<SvgIconStyle
						origin
						src={CartArrowIcon}
						size={50}
						sx={{ ml: 1.5, transform: "rotate(180deg)" }}
					/>
				)}
			</Button>
		</Box>
	);
}

export function BottomButtons({ left, right }) {
	const arr = [{ ...left }, { ...right }].filter((item) => {
		return Object.keys(item).length;
	});
	return (
		<Stack direction="row">
			{arr.map((item, i) => (
				<Button
					key={i}
					fullWidth
					variant="contained"
					onClick={item.onClick}
					disabled={item.disabled}
					sx={{
						borderRadius: 0,
						height: 80,
						display: "flex",
						alignItems: "center",
						color: i === 0 ? "black" : "white",
						bgcolor: i === 0 ? "grey.400" : "primary.main",
						"&:hover": {
							backgroundColor: i === 0 ? "grey.400" : "primary.main",
						},
					}}
				>
					{item.icon ? (
						<SvgIconStyle src={item.icon} size={32} sx={{ mr: 1 }} />
					) : null}
					<Typography variant="h2">{item.label}</Typography>
				</Button>
			))}
		</Stack>
	);
}

export function CartCard({ language, item, onClick, t, ...other }) {
	const changeKey = language.replace(/^([a-z])/, (_, c) => c.toUpperCase());

	return (
		<Box
			{...other}
			sx={{
				backgroundColor: "white",
				borderRadius: "4px",
				p: 1.25,
				position: "relative",
				display: "flex !important",
				flexDirection: "column !important",
				justifyContent: "space-between",
				width: 235,
				height: 172,
			}}
		>
			<Button
				onClick={onClick}
				sx={{ position: "absolute", top: 10, right: 10, p: 0 }}
			>
				<SvgIconStyle src={CancelIcon} size={24} sx={{ color: "grey.300" }} />
			</Button>

			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "space-between",
				}}
			>
				<Typography
					variant="h5"
					mr={2.75}
					sx={{
						textOverflow: "ellipsis",
						overflow: "hidden",
						wordBreak: "break-all",
						WebkitLineClamp: 2,
						WebkitBoxOrient: "vertical",
						display: "-webkit-box",
						lineHeight: "120%",
						mb: 1.25,
					}}
				>
					{item?.menuName?.[`text${changeKey || "koKr"}`]}
				</Typography>

				{/* 옵션 */}
				{(item.optionMode === "TOP" || item.optionMode === "SELECT") && (
					<Typography
						variant="body2"
						sx={{
							lineHeight: "120%",
							textOverflow: "ellipsis",
							overflow: "hidden",
							WebkitLineClamp: 1,
							WebkitBoxOrient: "vertical",
							display: "-webkit-box",
						}}
					>
						{item?.optionDTOs?.map((x, i) =>
							i === item?.optionDTOs.length - 1
								? `${x.name[`text${changeKey || "koKr"}`]}`
								: `${x.name[`text${changeKey || "koKr"}`]}, `
						)}
					</Typography>
				)}
			</Box>

			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "space-between",
				}}
			>
				{/* 수령시간 */}
				{item.mode === "TIME" && (
					<>
						{item?.menuType && (
							<Typography
								color="grey.200"
								variant="body1"
								sx={{
									lineHeight: "120%",
									mb: 0.5,
									textOverflow: "ellipsis",
									overflow: "hidden",
									WebkitLineClamp: 1,
									WebkitBoxOrient: "vertical",
									display: "-webkit-box",
								}}
							>
								{item?.menuType}
							</Typography>
						)}
						<Typography
							color="grey.200"
							variant="body1"
							sx={{ lineHeight: "120%", mb: 1.25 }}
						>
							{t("receive-time")} : {fDate(item.orderTime, "HH:mm")}
						</Typography>
					</>
				)}

				<Stack
					direction="row"
					alignItems="center"
					justifyContent="space-between"
				>
					<Typography variant="h5">
						{t("unit", { count: item.buyCount })}
					</Typography>
					<Typography variant="h5" color="primary.main">
						{t("price", { price: Number(item.paymentPrice).toLocaleString() })}
					</Typography>
				</Stack>
			</Box>
		</Box>
	);
}

import DefaultThumb from "assets/image/default_thumb.png";
export function OrderCard({ language, item, removeItem, t, ...other }) {
	const changeKey = language.replace(/^([a-z])/, (_, c) => c.toUpperCase());

	return (
		<Stack
			direction={"row"}
			gap={"20px"}
			container
			sx={{
				pointer: "cursor",
			}}
			{...other}
		>
			<Box
				item
				xs={3}
				sx={{ backgroundColor: item.image ? "transparent" : "grey.600" }}
			>
				<Box
					sx={{
						backgroundColor: "grey.400",
						width: "200px",
						minWidth: "200px",
						height: "200px",
						borderRadius: "4px",
						background: `center/contain no-repeat url(${
							item.image ? item.image : DefaultThumb
						})`,
					}}
				/>
			</Box>
			<Box
				sx={{
					width: "100%",
					display: "flex",
					flexDirection: "column",
					justifyContent: "space-between",
					height: "100%",
					// minHeight:'200px'
				}}
			>
				<Stack gap={0.25}>
					<Stack
						direction="row"
						alignItems="flex-start"
						justifyContent="space-between"
					>
						<Typography
							variant="h5"
							mr={2.75}
							sx={{
								textOverflow: "ellipsis",
								overflow: "hidden",
								wordBreak: "break-all",
								WebkitLineClamp: 2,
								WebkitBoxOrient: "vertical",
								display: "-webkit-box",
								lineHeight: "120%",
							}}
						>
							{item?.menuName?.[`text${changeKey || "koKr"}`]}
						</Typography>
						<Button sx={{ p: 0 }} onClick={() => removeItem(item)}>
							<SvgIconStyle src={CancelIcon} size={34} color={"black"} />
						</Button>
					</Stack>

					{/* 옵션 */}
					{item.menuType ? (
						<Typography variant="subtitle1">{item?.menuType || ""}</Typography>
					) : null}
					{item.orderTime ? (
						<Typography variant="body2">
							{t("receive-time")} : {fDate(item.orderTime, "HH:mm")}
						</Typography>
					) : null}
					{(item.optionMode === "TOP" || item.optionMode === "SELECT") && (
						<Typography
							variant="subtitle1"
							sx={{
								lineHeight: "120%",
								textOverflow: "ellipsis",
								overflow: "hidden",
								WebkitLineClamp: 1,
								WebkitBoxOrient: "vertical",
								display: "-webkit-box",
							}}
						>
							{item?.optionDTOs?.map((x, i) =>
								i === item?.optionDTOs.length - 1
									? `${x.name[`text${changeKey || "koKr"}`]}`
									: `${x.name[`text${changeKey || "koKr"}`]}, `
							)}
						</Typography>
					)}

					{/* <Typography variant="body2">{item?.businessName || ""}</Typography> */}
				</Stack>

				<Stack direction="row" alignItems="center" gap={3.5} mt={1}>
					<Typography
						variant="h4"
						color="primary.main"
						className="right-sep"
						sx={{ "&::after": { ml: 3.5 } }}
					>
						{t("price", {
							price: Number(item?.paymentPrice || 0).toLocaleString(),
						})}
					</Typography>
					<Typography variant="subtitle1">
						{t("unit", { count: item?.buyCount })}
					</Typography>
				</Stack>
			</Box>
		</Stack>
	);
}

export function EmailInput({
	onSelect,
	errors,
	sx,
	selected,

	emailValue,
	onEmailTypeChange,
	onClick,
	...other
}) {
	const Email_List = [
		{ label: "Direct Text Input", value: "write" },
		{ label: "gmail.com", value: "gmail.com" },
		{ label: "qq.com", value: "qq.com" },
		{ label: "naver.com", value: "naver.com" },
		{ label: "nate.com", value: "nate.com" },
		{ label: "daum.net", value: "daum.net" },
		{ label: "kakao.com", value: "kakao.com" },
	];

	// 셀렉트 버튼 아이콘
	const CustomDownArrow = (props) => (
		<img src={DownArrowIcon} alt="down arrow" {...props} />
	);

	return (
		<Grid container sx={{ sx }}>
			{/* 이메일 아이디 입력 칸 */}
			<Grid item xs={5.5}>
				<CommonInput
					id="email"
					placeholder={"Enter Email ID"}
					errors={errors}
					onClick={() => onClick("email")}
					sx={{
						maxHeight: "unset",
						height: 80,
						padding: 0,
						marginBottom: 0,
						input: {
							fontSize: "32px !important",
							borderBottom: "3px solid #BDBDBD !important",
						},
						fieldset: {
							border: "none",
						},
					}}
					{...other}
				/>
			</Grid>

			{/* @ 영역 */}
			<Grid
				item
				xs={1}
				sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
			>
				<Typography sx={{ fontSize: 40 }}>@</Typography>
			</Grid>

			{/* 도메인 입력 칸 */}
			<Grid item xs={5.5}>
				<Box sx={{ position: "relative" }}>
					<Select
						fullWidth
						onChange={onSelect}
						defaultValue="write"
						IconComponent={CustomDownArrow}
						sx={{
							...EmailInputStyle,
						}}
						renderValue={(value) => (value === "write" ? null : value)}
					>
						{Email_List.map((item, i) => (
							<MenuItem
								key={i}
								value={item.value}
								className="email-select-item"
							>
								{item.label}
							</MenuItem>
						))}
					</Select>
					{selected === "write" ? (
						<CommonInput
							id="emailType"
							value={emailValue}
							onChange={onEmailTypeChange}
							placeholder={"example.com"}
							onClick={() => onClick("type")}
							sx={{
								...EmailSelectInputStyle,
							}}
						/>
					) : null}
				</Box>
			</Grid>
		</Grid>
	);
}

// ---------- info page ----------
// 결제 전, 외국인 이메일 입력 모달
export function ConfirmEmail({
	open,
	onSubmit,
	onCancel,
	content,
	t,
	foreigner,
	termAgree,
	setTermAgree,
	...other
}) {
	return (
		<CommonModal
			open={open}
			footer={{ label: t("check"), onClick: onSubmit, disabled: !termAgree }}
			subFooter={{ label: t("re-input"), onClick: onCancel }}
			{...other}
			width={510}
		>
			<Box sx={{ textAlign: "center", py: 2 }}>
				<Typography variant="h3" fontSize={24} mb={2}>
					{t("check-email")}
				</Typography>
				<Typography fontSize={34} mb={2} sx={{ wordBreak: "break-word" }}>
					{content}
				</Typography>
				<Typography fontSize={20} color="grey.middle">
					{t("confirm-info")}
				</Typography>

				<Divider sx={{ margin: "16px 0" }} />

				<Typography variant="h5" fontSize={16} mb={2}>
					{t("confirm-title")}
				</Typography>
				<Typography
					fontSize={16}
					color="grey.middle"
					sx={{
						my: 3,
						whiteSpace: "break-spaces",
						textAlign: "left",
					}}
				>
					{t("confirm-mobile-term")}
				</Typography>
				<FormControlLabel
					control={
						<Checkbox
							disableRipple
							icon={<SvgIconStyle src={UncheckedIcon} size={24} origin />}
							checkedIcon={<SvgIconStyle src={CheckedIcon} size={24} origin />}
							checked={termAgree}
							onChange={(e) => setTermAgree(e.target.checked)}
						/>
					}
					label={
						<Typography
							variant="body1"
							fontSize={18}
							display="inline"
							textAlign={"left"}
						>
							<Typography
								color={"primary.main"}
								variant="body1"
								fontSize={20}
								fontWeight={900}
								display={"inline"}
							>
								{`[${t("necessary")}] `}
							</Typography>
							{t("confirm-mobile-agree")}
						</Typography>
					}
					sx={{ alignItems: "center", m: 0 }}
				/>
			</Box>
		</CommonModal>
	);
}

// 결제 전, 내국인 휴대폰번호 입력 모달
export function ConfirmMobile({
	open,
	onSubmit,
	onCancel,
	content,
	infoTerm,
	t,
	termAgree,
	setTermAgree,
	...other
}) {
	return (
		<CommonModal
			open={open}
			footer={{ label: t("check"), onClick: onSubmit, disabled: !termAgree }}
			subFooter={{ label: t("re-input"), onClick: onCancel }}
			{...other}
			width={510}
		>
			<Box sx={{ textAlign: "center", padding: "0 16px" }}>
				<Typography variant="h3" fontSize={24} mb={2}>
					{t("purchase-guide")}
				</Typography>
				<Typography fontSize={34} mb={2}>
					{content.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`)}
				</Typography>
				<Typography fontSize={20} whiteSpace={"pre-line"} color="grey.middle">
					{t("confirm-info")}
				</Typography>

				<Divider sx={{ margin: "16px 0" }} />
				<Typography variant="h5" fontSize={16} mb={2}>
					{t("confirm-title")}
				</Typography>
				<Typography
					fontSize={16}
					color="grey.middle"
					sx={{
						my: 3,
						whiteSpace: "break-spaces",
						textAlign: "left",
					}}
				>
					{t("confirm-mobile-term")}
				</Typography>
				<FormControlLabel
					control={
						<Checkbox
							disableRipple
							icon={<SvgIconStyle src={UncheckedIcon} size={24} origin />}
							checkedIcon={<SvgIconStyle src={CheckedIcon} size={24} origin />}
							checked={termAgree}
							onChange={(e) => setTermAgree(e.target.checked)}
						/>
					}
					label={
						<Typography
							variant="body1"
							fontSize={18}
							display="inline"
							textAlign={"left"}
						>
							<Typography
								color={"primary.main"}
								variant="body1"
								fontSize={20}
								fontWeight={900}
								display={"inline"}
							>
								{`[${t("necessary")}] `}
							</Typography>
							{t("confirm-mobile-agree")}
						</Typography>
					}
					sx={{ alignItems: "center", m: 0 }}
				/>
			</Box>
		</CommonModal>
	);
}
// ---------- info page ----------

// export function SelectPayMethod({ onClick }) {
//   return (
//     <Grid container spacing={2} mt={3}>
//       {[
//         { label: "카드결제", key: "card" },
//         {
//           label: "모바일페이",
//           key: "pay",
//           sub: "삼성페이 / 애플페이 / QR결제",
//         },
//       ].map((item, i) => (
//         <Grid item key={i} xs={6}>
//           <Button
//             sx={{
//               width: "100%",
//               border: "1px solid",
//               borderColor: "grey.300",
//               borderRadius: 1,
//               minHeight: "200px",
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               color: "black",
//             }}
//             onClick={() => onClick(item)}
//           >
//             <Box sx={{ textAlign: "center" }}>
//               <Typography variant="h2" fontSize={30}>
//                 {item.label}
//               </Typography>
//               {item.sub && (
//                 <Typography color="grey.middle" fontSize={24}>
//                   {item.sub}
//                 </Typography>
//               )}
//             </Box>
//           </Button>
//         </Grid>
//       ))}
//     </Grid>
//   );
// }

export function GoListButton({ onClick, t }) {
	return (
		<Box sx={{ textAlign: "center" }}>
			<Button
				// onClick={() => router.push("/items/list")}
				onClick={onClick}
				variant="outlined"
				sx={{
					alignItems: "center",
					color: "black",
					borderColor: "grey.400",
					px: 4,
					my: 5,
				}}
			>
				<SvgIconStyle src={MenuIcon} size={20} sx={{ mr: 1 }} />
				<Typography fontSize={20} fontWeight={700}>
					{/* 목록보기 */}
					{t("menu")}
				</Typography>
			</Button>
		</Box>
	);
}

export function AddCartButton({
	sx,
	onClick,
	disabled,
	isSoldOut,
	requireOption,
	t,
}) {
	return (
		<Box sx={{ ...sx, textAlign: "center" }}>
			<Button
				disabled={disabled}
				variant="contained"
				sx={{
					py: 1.5,
					px: 6,
					"&:active": { backgroundColor: "primary.main" },
				}}
				onClick={onClick}
			>
				<SvgIconStyle src={CartIcon} size={28} sx={{ mr: 1 }} />
				{/* 장바구니 담기 */}
				<Typography variant="subtitle1">
					{isSoldOut
						? t("sold-out")
						: requireOption
						? t("select-option")
						: t("add-cart")}
				</Typography>
			</Button>
		</Box>
	);
}

export function FastestButton({ onClick }) {
	return (
		<Box>
			<Button
				variant="contained"
				sx={{
					py: 1,
					fontSize: 16,
					"&:hover,&:active": { backgroundColor: "primary.main" },
				}}
				// onClick={() => setOpen("fastest")}
				onClick={onClick}
			>
				가장 빠른 시간 구매
			</Button>
		</Box>
	);
}

export function Loading({ size, circleSize, sx }) {
	return (
		<Stack
			direction="column"
			justifyContent="center"
			alignItems="center"
			sx={{
				height: "100%",
				position: "relative",

				...sx,
			}}
		>
			<SvgIconStyle
				src={SymbolIcon}
				origin
				sx={{
					width: size ? size : "40px",
					height: size ? size : "40px",
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%,-50%)",
				}}
			/>
			<CircularProgress size={circleSize ? circleSize : 80} thickness={2} />
		</Stack>
	);
}
